import AccordionTable from './AccordionTable';

export default AccordionTable;
